import React, { useEffect, useState } from "react";
import api from "../../../services/api";
import { Button } from "../../../components/ui";
import "./Corrections.css";
const categories = {
  team_income: "Доход команды",
  tax: "Налог",
  production: "Производственные расходы",
  non_production: "Непроизводственные расходы",
};
export default function ServicePeriodEditor({ groupId }) {
  const [rows, setRows] = useState([]),
    [teams, setTeams] = useState([]),
    [templates, setTemplates] = useState([]),
    [template, setTemplate] = useState(""),
    [error, setError] = useState(""),
    [busy, setBusy] = useState(false),
    [loading, setLoading] = useState(true),
    [loadedGroup, setLoadedGroup] = useState(null),
    [saved, setSaved] = useState(false);
  useEffect(() => {
    let active = true;
    setSaved(false);
    setLoading(true);
    setError("");
    api
      .get(`/company/correction-service-periods/${groupId}`)
      .then((r) => {
        if (active) {
          setLoadedGroup(groupId);
          setRows(r.data.services || []);
          setTeams(r.data.teams || []);
          setTemplates(r.data.templates || []);
        }
      })
      .catch(() => {
        if (active) setError("Не удалось загрузить обслуживание");
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [groupId]);
  const total = rows.reduce((s, r) => s + (Number(r.percentage) || 0), 0);
  const change = (i, field, value) => {
    setRows((rs) => rs.map((r, j) => (i === j ? { ...r, [field]: value } : r)));
    setSaved(false);
  };
  const save = async () => {
    setBusy(true);
    setError("");
    try {
      const r = await api.put(
        `/company/correction-service-periods/${groupId}`,
        { services: rows },
      );
      setRows(r.data.services);
      setSaved(true);
    } catch (e) {
      setError(e.response?.data?.error || "Не удалось сохранить");
    } finally {
      setBusy(false);
    }
  };
  if (loading) return <p role="status">Загрузка обслуживания…</p>;
  if (loadedGroup !== groupId) return <p role="alert">{error}</p>;
  return (
    <div className="cw-service-editor">
      <p>
        Стартовые проценты обслуживания для новых корректировок. При первом
        открытии используются существующие правила «ПД». Сохранённые
        корректировки не меняются.
      </p>
      {error && (
        <p role="alert" className="cw-error">
          {error}
        </p>
      )}
      {saved && <p role="status">Обслуживание периода сохранено</p>}
      <div className="cw-service-actions">
        <select
          aria-label="Шаблон обслуживания"
          value={template}
          onChange={(e) => setTemplate(e.target.value)}
        >
          <option value="">Взять из типа распределения…</option>
          {templates.map((t) => (
            <option key={t.distribution_type}>{t.distribution_type}</option>
          ))}
        </select>
        <Button
          variant="secondary"
          disabled={!template}
          onClick={() => {
            if (
              rows.length &&
              !window.confirm(
                "Заменить текущие строки обслуживания выбранным шаблоном?",
              )
            )
              return;
            setRows(
              templates.find((t) => t.distribution_type === template)?.rows ||
                [],
            );
            setSaved(false);
          }}
        >
          Подставить
        </Button>
      </div>
      <table>
        <thead>
          <tr>
            <th>Строка обслуживания</th>
            <th>Категория</th>
            <th>% от стоимости</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.key}>
              <td>
                {r.category === "team_income" ? (
                  <select
                    aria-label={`Название строки ${i + 1}`}
                    value={r.name}
                    onChange={(e) => change(i, "name", e.target.value)}
                  >
                    <option value="">Выберите команду</option>
                    {teams.map((t) => (
                      <option key={t.id} value={t.name}>
                        {t.name}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    aria-label={`Название строки ${i + 1}`}
                    value={r.name}
                    onChange={(e) => change(i, "name", e.target.value)}
                  />
                )}
              </td>
              <td>
                <select
                  aria-label={`Категория строки ${i + 1}`}
                  value={r.category}
                  onChange={(e) => change(i, "category", e.target.value)}
                >
                  {Object.entries(categories).map(([v, label]) => (
                    <option key={v} value={v}>
                      {label}
                    </option>
                  ))}
                </select>
              </td>
              <td>
                <input
                  aria-label={`Процент строки ${i + 1}`}
                  type="number"
                  min="0"
                  max="100"
                  step="any"
                  value={r.percentage}
                  onChange={(e) => change(i, "percentage", e.target.value)}
                />
              </td>
              <td>
                <Button
                  variant="ghost"
                  onClick={() => {
                    setRows((rs) => rs.filter((_, j) => j !== i));
                    setSaved(false);
                  }}
                  aria-label={`Убрать строку ${i + 1}`}
                >
                  ×
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="cw-service-actions">
        <Button
          variant="secondary"
          onClick={() => {
            setRows((rs) => [
              ...rs,
              {
                key: crypto.randomUUID(),
                name: "",
                category: "team_income",
                percentage: 0,
              },
            ]);
            setSaved(false);
          }}
        >
          + Добавить строку
        </Button>
        <strong>
          Обслуживание: {total.toFixed(2)}% · Остаётся на производство:{" "}
          {(100 - total).toFixed(2)}%
        </strong>
        <Button
          variant="primary"
          disabled={busy || total >= 100}
          onClick={save}
        >
          Сохранить обслуживание
        </Button>
      </div>
    </div>
  );
}
